import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledTooltipContent = styled.p`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["400"],
        $size: 14,
    })};
    line-height: 20px;
    margin: 0;
    text-align: center;
`;

export const StyledButton = styled.div`
    margin-left: 16px;
`;
